<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="src"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .85), rgba(5, 11, 31, .55)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="800"
          width="100%"
        >
          <base-heading title="Software Development at its Best" />

          <base-body>
            Datacom Business Systems specializes in helping businesses and not-for-profit organizations
						by providing the newest technology to help them stay ahead of the curve and increase operational efficiencies.
						Our success is generated by the success created for our clients. 
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn
						:to="{name: 'About'}">
              Check us out
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
							:to="{name: 'Contact'}"
            >
              Contact Sales
            </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
			},
			src () {
        return this.$route.meta.src
      },
    },
  }
</script>
